import axios from 'axios'
import {APIHOST} from "@/settings";
import SessionStorage from "sessionstorage";

class CompanyService {
    search({query, limit, soliq}) {
        return axios.get(`${APIHOST}/api/Company`, {
            params: {
                search: (typeof (query) === "undefined" || query === null) ? "" : query,
                limit: typeof (limit) === 'number' ? (+limit) : null,
                soliq: typeof (soliq) === 'boolean' ? soliq : null
            }
        })
    }

    getSoliqDetails(inn) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/SoliqCompany/${inn}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    getVatCode(inn) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'))

        return axios.get(`${APIHOST}/api/CompanyVatCode`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`},
            params: {id: inn}
        })
    }

    getProductCatalogs(inn) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'))

        return axios.get(`${APIHOST}/api/CompanyProductCatalog`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`},
            params: {id: inn}
        })
    }
    getCompanyCatalogCodesInfo() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'))
        
        return axios.get(`${APIHOST}/api/CompanyCatalogCodesInfo`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`},
        })
    }

    getBillingInfo() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/CompanyBilling`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    getLgota() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/Lgota`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }
    getCatalogCodeLgota(code){
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/CatalogCodeLgota`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`},
            params:{
                searchText:code
            }
        }).then(res=>{
            return res.data
        }).catch(err=>{
            throw err
        });
    }
}

export default new CompanyService();
